import React, { useState, useCallback } from 'react';
import Autosuggest from 'react-autosuggest';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
import AutosuggestHighlightParse from 'autosuggest-highlight/parse';

import './styles.css';

const AsyncAutosuggestWithHightlight = props => {
  const {
    placeholder = 'Search',
    value = '',
    name,
    onChange,
    onSelected,
    onSearchRequested,
  } = props;

  const [suggestions, setSuggestions] = useState([]);

  const getSuggestionValue = suggestion => suggestion.label;

  const renderSuggestion = (suggestion, { query }) => {
    const nameMatches = AutosuggestHighlightMatch(suggestion.label, query);
    const nameParts = AutosuggestHighlightParse(suggestion.label, nameMatches);

    return (
      <div className='suggestion-item__name'>
        {nameParts.map((part, index) => {
          const className = part.highlight
            ? 'sugggestion-item-highlight'
            : null;

          return (
            <span className={className} key={index}>
              {part.text}
            </span>
          );
        })}
      </div>
    );
  };

  const debounceRequest = useCallback(
    debounce(value => {
      onSearchRequested(value).then((records = []) => {
        setSuggestions(records);
      });
    }, 500),
    []
  );

  const debounceChange = useCallback(
    debounce(value => {
      onChange(name, value);
    }, 20),
    []
  );

  const onSuggestionsFetchRequested = ({ value, reason }) => {
    if (reason === 'input-changed') {
      debounceRequest(value);
    }
  };

  const onChangeInput = (event, { newValue, method }) => {
    if (method !== 'click') {
      debounceChange(newValue);
    }
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onSuggestionSelected = (event, { suggestion }) => {
    onSelected(name, suggestion);
    setSuggestions([]);
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      onSuggestionSelected={onSuggestionSelected}
      inputProps={{
        placeholder,
        value,
        onChange: onChangeInput,
      }}
    />
  );
};

AsyncAutosuggestWithHightlight.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSelected: PropTypes.func.isRequired,
  onSearchRequested: PropTypes.func.isRequired,
};

export default AsyncAutosuggestWithHightlight;
